// Vendor imports
const classNames = require('classnames')
const _ = require('lodash')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { InterestFollowCircleButton } = require('client-v2/common/components/buttons')
const LazyImage = require('client-v2/common/components/lazy-image')
const { usePropsEventCallback } = require('client-v2/common/hooks/callbacks')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('InterestCard')

/**
 * This is a constant so that it does not change between renders
 * @type {[]}
 * @readonly
 */
const NO_IMAGE_URLS = []

function InterestCard(props) {
  const { interest } = props
  const preferredImageUrl = _.get(interest, 'profile_image_urls.small')
  const fallbackImageUrls = _.get(interest, 'profile_images', NO_IMAGE_URLS)
  // Hooks
  const imageSources = React.useMemo(
    () => _.compact([ preferredImageUrl, ...fallbackImageUrls ]),
    [ preferredImageUrl, fallbackImageUrls ]
  )
  const onCardClick = usePropsEventCallback(props, 'onCardClick')
  const onFollowClick = usePropsEventCallback(props, 'onFollowClick')
  // Render
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('inner', {
          checked: interest.isFollowing
        }),
        onClick: onCardClick
      },
        tag(LazyImage, {
          className: bem.element('image'),
          sources: imageSources
        }),
        tag('span', {
          className: bem.element('name')
        },
          interest.name
        ),
        tag(InterestFollowCircleButton, {
          className: bem.element('follow-button'),
          checked: interest.isFollowing,
          onClick: onFollowClick
        })
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const InterestModelRecord = require('client-v2/common/models/interest/record')
  const { PageContextOverlayRecord } = require('client-v2/common/models/page-context/records')

  InterestCard.propTypes = {
    // Values
    className: PropTypes.string,
    interest: PropTypes.shape(InterestModelRecord.propTypes).isRequired,
    pageContext: PropTypes.shape(PageContextOverlayRecord.propTypes),
    // Callbacks
    onCardClick: PropTypes.func,
    onFollowClick: PropTypes.func
  }
}

module.exports = InterestCard
